<div class="page_layout">
  <div class="page_layout__container">
    <div class="page_layout__container__header">Export Menu</div>
    <div class="page_layout__container__body">
      <div class="page_layout__container__body__drop">
        <app-dropdown-admin
          class="dropdowncategories"
          [input_dropdown_title]="'Select Category'"
          [input_dropdown_options]="categories"
          (selectedId)="onCategorySelect($event)"
        />
      </div>
      <div class="page_layout__container__body__CategoryName">{{ header }}</div>
      <div class="export">
        <button
          class="exportButton exportButton--green"
          (click)="exportToExcel()"
        >
          <svg class="navigation__icon navigation__icon--white">
            <use xlink:href="images/sprites6.svg#icon-excel"></use>
          </svg>
          Export Menu Excel
        </button>

        <button class="exportButton" (click)="downloadPDF()">
          <svg class="navigation__icon navigation__icon--white">
            <use xlink:href="images/sprites5.svg#icon-file-pdf"></use>
          </svg>
          Export Menu PDF
        </button>
      </div>
    </div>
  </div>
</div>

<app-admin-success-message> </app-admin-success-message>
